import { useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
// import Footer from "../components/Footer";
import { Outlet } from "react-router-dom";
import { Box, Toolbar } from "@mui/material";

const Layout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  // const toggleSidebar = () => {
  //   console.log("sidebarCollapsed", sidebarCollapsed);
  //   setSidebarCollapsed(!sidebarCollapsed);
  // };

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      <Header onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)} />
      <Sidebar open={sidebarCollapsed} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          mt: 12,
          backgroundColor: "#f5f5f5",
          minHeight: "100vh",
          minWidth: 0, // Critical for flexbox children containing DataGrid
        }}
      >
        {/* <Toolbar /> */}
        <Outlet />
      </Box>
    </Box>
    //   {/* <div className={`wrapper ${sidebarCollapsed ? "sidebar-collapse" : ""}`}> */}
    //   {/* <Header onToggleSidebar={toggleSidebar} />
    //   <Sidebar />
    //   <div className="content-wrapper">
    //     <Outlet />
    //   </div> */}
    //   {/* <Footer /> */}
    // // </div>
  );
};

export default Layout;
